/* Coverflow Gallery - Originkit port (showTitle:false).
   Progressive enhancement: converts each product page gallery
   (.phero__media: main image + .pgallery__thumbs) into a 3D coverflow. */
(function () {
  'use strict';
  var css = ''
    + '.coverflow{position:relative;width:100%;min-width:280px;min-height:320px;'
    + 'height:clamp(340px,34vw,520px);display:flex;align-items:center;'
    + 'justify-content:center;perspective:1600px;overflow:hidden;outline:none}'
    + '.coverflow__stage{position:relative;transform-style:preserve-3d}'
    + '.cf-card{position:absolute;left:50%;top:50%;overflow:hidden;'
    + 'transform-style:preserve-3d;transform-origin:center center;background:#FFF8F0}'
    + '.cf-card img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;'
    + 'user-select:none;-webkit-user-drag:none;display:block}'
    + '.cf-dim{position:absolute;inset:0;background:#000;pointer-events:none}'
    + '.phero__media .phero__badge--cf{position:static;display:inline-block;margin:0 0 14px}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function initCoverflow(root, slides, opts) {
    var o = Object.assign({
      cardWidth: 440, cardHeight: 440,
      radius: 3, tilt: 12, sideTilt: 8, gap: 8, opacity: 60,
      duration: 0.6, ease: 'cubic-bezier(0.22, 1, 0.36, 1)',
      autoplay: false, autoplayDirection: 'rightToLeft', delay: 2.5,
      maxVisible: 2, depth: 240, scaleStep: 0.16
    }, opts || {});
    var n = slides.length;
    var active = 0, locked = false;
    var dim = 1 - Math.max(0, Math.min(100, o.opacity)) / 100;
    var stage = document.createElement('div');
    stage.className = 'coverflow__stage';
    root.appendChild(stage);
    var cards = slides.map(function (s, i) {
      var card = document.createElement('div');
      card.className = 'cf-card';
      card.style.transition = 'transform ' + o.duration + 's ' + o.ease + ', opacity ' + o.duration + 's ' + o.ease;
      var img = document.createElement('img');
      img.src = s.src; img.alt = s.alt || ''; img.draggable = false;
      img.loading = i === 0 ? 'eager' : 'lazy';
      var dimEl = document.createElement('div');
      dimEl.className = 'cf-dim';
      dimEl.style.transition = 'opacity ' + o.duration + 's ' + o.ease;
      card.appendChild(img); card.appendChild(dimEl);
      card.addEventListener('click', function () {
        if (o.autoplay || locked) return;
        lock();
        active = (i === active) ? (active + 1) % n : i;
        update();
      });
      stage.appendChild(card);
      return { card: card, dimEl: dimEl };
    });
    function lock() {
      locked = true;
      setTimeout(function () { locked = false; }, Math.max(50, o.duration * 1000));
    }
    function update() {
      var w = Math.min(o.cardWidth, root.clientWidth * 0.62);
      var h = w * (o.cardHeight / o.cardWidth);
      stage.style.width = w + 'px';
      stage.style.height = h + 'px';
      var r = (Math.max(0, Math.min(20, o.radius)) / 20) * (Math.min(w, h) / 2);
      var scale = w / o.cardWidth;
      cards.forEach(function (c, i) {
        var rel = i - active;
        if (rel > n / 2) rel -= n;
        if (rel < -n / 2) rel += n;
        var ax = Math.abs(rel);
        var visible = ax <= o.maxVisible;
        var isActive = rel === 0;
        var sc = Math.max(0.4, 1 - ax * o.scaleStep);
        var tx = rel * (o.gap * 30) * scale;
        var tz = -ax * o.depth * scale;
        c.card.style.width = w + 'px';
        c.card.style.height = h + 'px';
        c.card.style.borderRadius = r + 'px';
        c.card.style.transform = 'translate(-50%, -50%) translateX(' + tx + 'px) translateZ(' + tz + 'px)'
          + ' rotateY(' + (-rel * o.tilt) + 'deg) rotateZ(' + (rel * o.sideTilt) + 'deg) scale(' + sc + ')';
        c.card.style.opacity = visible ? 1 : 0;
        c.card.style.cursor = (o.autoplay || isActive) ? 'default' : 'pointer';
        c.card.style.pointerEvents = (visible && !o.autoplay) ? 'auto' : 'none';
        c.card.setAttribute('aria-hidden', String(!visible));
        c.dimEl.style.opacity = isActive ? 0 : dim;
      });
    }
    function step(dir) {
      if (locked) return;
      lock();
      active = ((active + dir) % n + n) % n;
      update();
    }
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });
    window.addEventListener('resize', update);
    if (o.autoplay && n > 1) {
      var dir = o.autoplayDirection === 'leftToRight' ? -1 : 1;
      setInterval(function () { step(dir); }, Math.max(0.3, o.delay) * 1000);
    }
    update();
    return { next: function () { step(1); }, prev: function () { step(-1); } };
  }
  window.initCoverflow = window.initCoverflow || initCoverflow;

  function enhance() {
    var medias = document.querySelectorAll('.phero__media');
    Array.prototype.forEach.call(medias, function (media) {
      if (media.getAttribute('data-cf-done')) return;
      var thumbs = media.querySelector('.pgallery__thumbs');
      if (!thumbs) return;
      var btns = thumbs.querySelectorAll('.pgallery__thumb');
      var slides = [];
      Array.prototype.forEach.call(btns, function (b) {
        var img = b.querySelector('img');
        var src = b.getAttribute('data-full') || (img && (img.currentSrc || img.src));
        if (src) slides.push({ src: src, alt: img ? img.alt : '' });
      });
      if (slides.length < 2) return;
      media.setAttribute('data-cf-done', '1');
      var stage = media.querySelector('.phero__stage');
      var badge = media.querySelector('.phero__badge');
      var cf = document.createElement('div');
      cf.className = 'coverflow';
      cf.tabIndex = 0;
      cf.setAttribute('role', 'group');
      cf.setAttribute('aria-roledescription', 'carousel');
      if (badge) {
        badge.classList.add('phero__badge--cf');
        media.insertBefore(badge, media.firstChild);
      }
      if (stage) stage.remove();
      thumbs.remove();
      media.appendChild(cf);
      window.initCoverflow(cf, slides);
    });
  }
  if (document.readyState !== 'loading') enhance();
  else document.addEventListener('DOMContentLoaded', enhance);
})();
